import React from 'react';
import { Row, Col, Button, OverlayTrigger, Popover, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { PersonFill, Gear, QuestionSquare, DoorOpen, CircleFill } from 'react-bootstrap-icons';
import utils from '../../../utils';

function TenantUserBlock({ currentTenant, raiseSupport, windowSize, tenantName = null, resetToken }) {

  const { user, logout, loginWithRedirect, isAuthenticated } = useAuth0();

  //show user icon with signed in user name next to it if 
  //signed in, otherwise, make a menu that they can sign in 
  //with


  const showLoginPopup = () => {
    try {
      loginWithRedirect({ appState: { returnTo: window.location.pathname } });
    } catch (error) {
      console.log(error);
    }
  };

  const showLogoutPopup = () => {
    try {
      //clear login stuff
      utils.removeForceTenantValue();
      //forcest the userToken to reset to null 
      //needed for Workspaces with the Alchemy App
      resetToken();
      
      logout({ logoutParams: { returnTo: window.location.origin } });
    } catch (error) {
      console.log(error);
    }
  };

  return (

    <>
      <div className="user-block">
        {
          isAuthenticated ?
            <OverlayTrigger
              placement='bottom'
              trigger='click'
              key='bottom'
              rootClose
              overlay={
                <Popover id={`popover-positioned-bottom`} className='signin-modal' style={{ width: '300px' }}>
                  <div id="example-collapse-text" className={tenantName}>
                    <Row>
                      <Col>
                      {
                        user && user.name ?
                          <div className='tenant-info'>
                            <p className='label-small tenant-name'>
                              {user.name}
                            </p>
                            <p className='label-large tenant-email'>{user.email}</p>
                          </div>
                          : null
                      }
                      </Col>
                    </Row>
                    <Row>
                      <Col className="setting-feedback-login">
                        <div className="account-menu-actions">
                          {user?.email && currentTenant && (
                            <Nav.Link as={Link} to="/settings" onClick={() => document.body.click()} className="btn-ghost-lg">
                              <Gear className="svg-16" /> Settings
                            </Nav.Link>
                          )}

                          <button type="button" onClick={() => raiseSupport(true)} className="btn-ghost-lg p-i-0 m-i-0">
                            <QuestionSquare className="svg-16" /> Help & Feedback
                          </button>

                          <button type="button" onClick={showLogoutPopup} className="btn-ghost-lg p-i-0 m-i-0">
                            <DoorOpen className="svg-16" /> Sign Out
                          </button>
                        </div>
                      </Col>

                    </Row>
                    <Row>
                      <Col xs={12} className="body-small-condensed text-primary-light m-i-start-04">
                        <a href="https://linksbridge.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-secondary-light underline-none">Privacy Policy</a> 
                        <CircleFill className="surface-secondary-light m-i-start-04 m-i-end-04 svg-6" /> 
                        <a href="https://www.iubenda.com/terms-and-conditions/62216506" target="_blank" rel="noopener noreferrer" className="text-secondary-light underline-none">Terms of Service</a>
                      </Col>
                  </Row>
                  </div>
                </Popover>
              }
            >
              <Button id="nav-user-dropdown">
                <PersonFill
                  className="user-login-icon"
                  style={{
                    width: "auto",
                    height: "1.5em"
                  }}
                />
              </Button>
            </OverlayTrigger>
          :
          <Row onClick={() => { showLoginPopup() }}>
            <Col xs={12} className="landing-signin">
              <PersonFill
                className="user-login-icon"
                style={{
                  width: "auto",
                  height: "1.5em",
                  marginLeft: "5px"
                }} />
            </Col>
          </Row>
        }
        
      </div>
    </>
  )
}

export default TenantUserBlock;